<mat-card>
  <app-card-header
    [title]="'Asignar recorrido al vehículo'"
    [subtitle]="data.vehiculo?.identificacion"
    icono="route"
    [botonCerrar]="true"
    (cerrar)="onCancel()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <div class="content-grid">
      <!-- Selector de recorrido -->
      <div class="left-column">
        <app-info-banner
          icon="info"
          title="Seguimiento de recorrido"
          [closable]="false"
          message="Seleccioná un recorrido para asignar al vehículo.
            <strong>El sistema hará seguimiento en tiempo real</strong>
            del vehículo a lo largo del recorrido seleccionado."
        ></app-info-banner>

        <app-content-card title="Selección de recorrido" icon="route">
          <section class="inputs-group" style="flex-direction: column">
            <div>
              <ng-select
                id="recorrido-select"
                [(ngModel)]="recorridoSeleccionado"
                [items]="recorridos"
                bindLabel="nombre"
                bindValue="_id"
                placeholder="Recorrido"
                notFoundText="Sin resultados"
                [loading]="loading"
                (change)="onRecorridoChange()"
                [clearable]="true"
                appendTo="body"
                [searchable]="true"
                style="width: 100%"
              ></ng-select>
              <small class="ayuda">
                Seleccioná el recorrido que querés asignar al vehículo
              </small>
            </div>
          </section>
        </app-content-card>
      </div>

      <!-- Vista Previa del Recorrido -->
      <div class="right-column">
        <app-map-card
          [config]="mapCardConfig"
          [mapOptions]="matOptions"
        ></app-map-card>
      </div>
    </div>

    <!-- Qué va a pasar con el cumplimiento al asignar este recorrido. Se avisa
         acá, que es donde se toma la decisión: el panel del mapa no muestra nada
         hasta que haya un porcentaje real.

         Va a lo ancho y debajo de las dos columnas, no dentro de la izquierda:
         ahí crecía más que el mapa y descuadraba el diálogo. -->
    @if (recorridoDetalle) {
      <div class="cumplimiento-fila">
        <app-content-card
          [title]="
            mideCumplimiento
              ? 'Se va a medir el cumplimiento'
              : 'Sin medición de cumplimiento'
          "
          icon="checklist"
        >
          <section class="cumplimiento-aviso">
            @if (mideCumplimiento) {
              <p>
                Al asignarlo, el sistema compara cada reporte del vehículo
                contra esta traza y calcula qué porcentaje del recorrido hace
                realmente. El avance se ve en el panel del vehículo y sobre el
                mapa.
              </p>
              <ul>
                <li>
                  La traza mide
                  <b>{{ largoKm | number: '1.2-2' }} km</b>
                  y se divide en
                  <b>{{ cumplimiento?.tramos }} tramos</b>
                  donde cada uno aporta
                  <b>{{ cumplimiento?.resolucion | number: '1.1-1' }}%</b>
                  del total
                </li>
                <li>
                  Un reporte cuenta si está a menos de
                  <b>{{ cumplimiento?.toleranciaMetros }} m</b>
                  de la traza; más lejos que eso no suma cobertura
                </li>
                <li>
                  Se da por completado al llegar al
                  <b>{{ cumplimiento?.minimoPorcentaje }}%</b>
                  de cobertura
                </li>
                @if (cumplimiento?.inicioEstricto) {
                  <li class="importante">
                    <b>
                      Arranca a medir recién cuando el vehículo llegue al inicio
                      de la traza.
                    </b>
                    Si ya viene circulando por el medio, no va a empezar
                  </li>
                } @else {
                  <li>
                    Empieza a medir en cuanto el vehículo esté sobre la traza,
                    en cualquier punto
                  </li>
                }
                @if (cumplimiento?.porTiempo) {
                  <li>
                    También se controla el tiempo: se espera que lo complete en
                    <b>{{ cumplimiento?.duracionEsperada }} min</b>
                    con un margen del {{ cumplimiento?.toleranciaTiempo }}%
                  </li>
                }
                @if (cumplimiento?.esCiclico) {
                  <li>
                    Es cíclico: el porcentaje se mide
                    <b>por vuelta</b>
                    y se reinicia al pasar por el cierre
                  </li>
                }
                <li>
                  Si pasa
                  <b>{{ cumplimiento?.timeoutMinutos }} min</b>
                  sin reportes sobre la traza, la medición se cierra y queda
                  registrada
                </li>
              </ul>
            } @else {
              <p>
                Este recorrido no tiene la medición de cumplimiento activada,
                así que la asignación sólo sirve para el seguimiento y las
                reglas de desvío. No se va a calcular ningún porcentaje.
              </p>
              <small>
                Se activa editando el recorrido, en la sección "Cumplimiento del
                Recorrido".
              </small>
            }
          </section>
        </app-content-card>
      </div>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="onCancel()">
      Cancelar
    </button>
    <!-- Quitar es independiente de lo que esté elegido en el combo: antes sólo
         aparecía si la selección coincidía con el recorrido asignado, así que al
         cambiarla o limpiarla no quedaba forma de desasignar. -->
    @if (tieneRecorridoAsignado) {
      <button
        irxBoton="peligro-borde"
        type="button"
        (click)="onCancelRecorrido()"
        tooltip="Deja al vehículo sin recorrido asignado y corta el seguimiento"
      >
        <mat-icon>link_off</mat-icon>
        Quitar recorrido
      </button>
    }
    @if (puedeAsignar) {
      <button
        irxBoton="principal"
        type="button"
        (click)="onConfirmRecorrido()"
      >
        <mat-icon>play_arrow</mat-icon>
        {{
          tieneRecorridoAsignado
            ? 'Cambiar seguimiento actual'
            : 'Comenzar seguimiento'
        }}
      </button>
    }
  </mat-card-actions>
</mat-card>
